<template>
    <div class="dropdown-main-container" @click.stop="setIsOpenFixedList">
        <p class="text">{{ title }}</p>
        <div class="input">
            <wallet-icon class="dropdown-left-icon"/>
            <p class="dropdown-checked-value">{{ checkedValue }}</p>
            <chevron-down-icon class="dropdown-chevron-icon" />
        </div>
    </div>
</template>

<script>
import WalletIcon from '../resources/js/icons/WalletIcon.vue'
import {ChevronDownIcon} from 'vue-feather-icons'

export default {
    name: "Fixed-tab-list",
    components: {
        WalletIcon,
        ChevronDownIcon,
    },
    props: {
        title: {
            type: String,
            require: false
        },
        value: {
            type: Object,
            require: false
        },
    },
    data() {
        return {
          checkedValue: null
        }
    },
    async mounted() {

    },

    methods: {
        setIsOpenFixedList() {
            this.$emit('is-open-fixed-list')  
        }
    },
    computed: {

    },
    watch: {
        value(newVal, oldVal) {
            if (!newVal) {
                return
            }
            if (this.isCurrency) {
                this.checkedValue = newVal.code_alfa 
            } else {
                this.checkedValue = newVal.title 
            }
           let val = oldVal
           val
        },
    }
}
</script>

<style scoped>
    .dropdown-main-container {
        margin-bottom: 8px;
        display: flex;
        flex-direction: column;
        width: fit-content;
        position: relative;
        width: 100%;
        cursor: pointer;
    }
    .dropdown-main-container .text {
        font-size: 12px;
        color: #4A89DC;
        font-weight: 700;
        position: relative;
        top: 5px;
        margin: 0 0 0 7px;
        padding: 0 3px;
        line-height: 10px;
        background: #e8e8e8;
        width: fit-content;
    }
    .dropdown-main-container .input {
        padding: 11px 40px;
        font-size: 0.75rem;
        border: 1px rgba(0, 0, 0, 0.07) solid;
        border-radius: 10px;
        background: #e8e8e8;
        height: 53px;
    }
    .dropdown-left-icon {
        position: absolute;
        top: 25px;
        left: 10px;
        width: 23px;
        height: 23px;
    }
    .dropdown-chevron-icon {
        position: absolute;
        right: 10px;
        top: 29px;
        width: 17px;
        height: 17px;
        margin-left: auto;
        transition: all .25s ease;
    }
    .dropdown-checked-value {
        font-weight: 400;
        line-height: 35px;
        font-size: 12px;
        font-family: "Source Sans 3", sans-serif;
        color: #212529;
    }

</style>